import React from "react";
import { Outlet } from "react-router-dom";
import Nav from "../components/nav/Nav";
import { useJobContext } from "../context/JobContext";
import ServiceRequestPanel from "../components/panels/ServiceRequestPanel";

const AppLayout = ({
  isNavVisible,
  isCollapsed,
  closeNav,
}) => {


  const {
    showAddJob,
    setShowAddJob,
    jobToEdit,
    setJobToEdit,
    editedJob,
    setEditedJob,
  } = useJobContext();

  return (
    <div className="main-area">
      <Nav
        isVisible={isNavVisible}
        isCollapsed={isCollapsed}
        closeNav={closeNav}
      />

      {/* Mobile overlay */}
      {isNavVisible && window.innerWidth <= 768 && (
        <div className="sidebar-overlay" onClick={closeNav} />
      )}

      <div className="content-wrapper" style={{ position: "relative", flex: 1 }}>
        <div
          className={`content ${isNavVisible ? "" : "expanded"}`}
        >
          <Outlet />


          {showAddJob && (
            <ServiceRequestPanel
              showAddJob={showAddJob}
              setShowAddJob={setShowAddJob}
              jobToEdit={jobToEdit}
              setJobToEdit={setJobToEdit}
              editedJob={editedJob}
              setEditedJob={setEditedJob}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default AppLayout;